import Urls from "./Urls";
import {AuthManager} from "@cuatroochenta/co-admin-react-library";
import {METHOD} from "@cuatroochenta/co-generic-request";

export default class TaskExportMobilisConfiguration {

    private getGetInfo() {
        return {
            method: METHOD.METHOD_GET,
            headers: {
                'Authorization': 'Bearer ' + AuthManager.getAuthToken()
            }
        }
    }

    public get() {
        return fetch(Urls.URL_EXPORT_MOBILIS_CONFIGURATION, this.getGetInfo())
            .then(response => response.blob())
            .then(data => {return data});
    }

}